export default __webpack_public_path__ + "static/media/packer.e9d57cb4.svg";